export const SEARCHED_USER_IDS_CHANGED = 'searchedUserIdsChanged';

export function searchedUserIdsChanged(userIds) {
  return {
    type: SEARCHED_USER_IDS_CHANGED,
    userIds
  };
}
